function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import getHeaderHeight from '../../../helpers/getHeaderHeight';
var ArticleWhiteSpace = function ArticleWhiteSpace() {
  var _useState = useState(uuid()),
    _useState2 = _slicedToArray(_useState, 1),
    id = _useState2[0];
  var _useLocation = useLocation(),
    pathname = _useLocation.pathname;
  useEffect(function () {
    $(window).on('scroll', handleOnScroll);
    return function () {
      $(window).off('scroll', handleOnScroll);
    };
  }, []);
  useEffect(function () {
    handleOnScroll();
  }, [pathname]);
  var handleOnScroll = function handleOnScroll() {
    var sectionArr = [];
    $('#page section').each(function () {
      if (!$(this).attr('id')) return;
      sectionArr.push({
        id: $(this).attr('id')
      });
    });
    var target = null;
    if (sectionArr.length !== 0) target = sectionArr[sectionArr.length - 1].id;
    if (!target) return;
    var h = $("#".concat(target)).height();
    if ($(window).width() < 766) $("#".concat(id)).css({
      height: 0
    });else if (h < $(window).height()) $("#".concat(id)).css({
      height: $(window).height() - h - getHeaderHeight()
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    style: {
      width: '100%',
      height: 0
    }
  });
};
export default ArticleWhiteSpace;